import { formatCurrency } from '@bodilenergy/util';
import { BodilColor } from '~src/branding';
import { Icon } from '~src/components/Icon';
import { Root } from '~src/components/Root';
import { Heading } from '~src/components/Typography';
import { scrollElementIntoView } from '~src/hooks/useScroll';

import {
  AddressStreamer,
  EstimateBookingPanel,
  HeaderStreamer,
  LoanDisclaimer,
  OfferTypeSelector,
  SavingsEstimate,
  SuggestionBanner,
  TakeoverOverlay,
  TextButtonWithIcon,
} from '~src/components/EstimatePage';

import {
  BackgroundImage,
  BackgroundShading,
  MobileBottomPart,
  MobileMiddlePart,
  MobileTopPart,
  STANDARD_MARGIN,
} from './style';
import { EstimatePageProps } from '~src/model';
import { getBookingFormVariant } from './util';

export const EstimatePageMobileBodil = (props: EstimatePageProps) => {
  const {
    scrollReference,
    address,
    disabledProducts,
    fuelType,
    products,
    financing,
    savings,
    showLoan,
    setShowLoan,
    hasBbrData,
  } = props;
  const bookingFormVariant = getBookingFormVariant();

  return (
    <Root
      footer={false}
      header={false}
      pageStyle={{
        display: 'flex',
        flexFlow: 'column wrap',
        paddingLeft: 0,
        paddingRight: 0,
        gap: '12px',
      }}
    >
      <MobileTopPart>
        <BackgroundImage />

        <BackgroundShading />

        <OfferTypeSelector
          style={{ position: 'absolute', width: '100%', justifyContent: 'space-around', height: '48px' }}
          buttonStyle={{ marginTop: '8px' }}
          fuelType={fuelType}
        />

        <div
          style={{
            position: 'relative',
            marginTop: '72px',
          }}
        >
          <AddressStreamer address={address} style={{ marginLeft: STANDARD_MARGIN }} />

          <HeaderStreamer
            totalSaved={savings?.saved.price}
            showLoan={showLoan}
            style={{ marginLeft: STANDARD_MARGIN, marginRight: STANDARD_MARGIN, marginTop: '24px' }}
          />

          <SuggestionBanner
            style={{
              padding: STANDARD_MARGIN,
              marginTop: '48px',
              marginBottom: '48px',
            }}
            products={products}
          />

          <TextButtonWithIcon
            onClick={() => scrollElementIntoView(scrollReference)}
            icon={<Icon.Chevron color={BodilColor.base.white} direction='down' />}
          />
        </div>

        {(!hasBbrData || disabledProducts.length > 1) && (
          <TakeoverOverlay
            address={address}
            style={{
              marginLeft: STANDARD_MARGIN,
              marginRight: STANDARD_MARGIN,
            }}
          />
        )}
      </MobileTopPart>

      <MobileMiddlePart>
        <EstimateBookingPanel
          variant={bookingFormVariant}
          style={
            bookingFormVariant === 'offerIdentity'
              ? { width: '90%', marginLeft: STANDARD_MARGIN, marginRight: STANDARD_MARGIN }
              : undefined
          }
          defaultTitle={
            <Heading
              style={{
                fontSize: '24px',
                width: '400px',
                alignSelf: 'start',
                marginLeft: '8px',
              }}
            >
              Book et energirådgivermøde nu og spar{' '}
              <span style={{ color: BodilColor.ui.orange }}>
                {formatCurrency(savings?.saved.price, { decimals: 0 })}
              </span>{' '}
              årligt.
            </Heading>
          }
        />
      </MobileMiddlePart>

      {hasBbrData && disabledProducts.length <= 1 && (
        <MobileBottomPart>
          <BackgroundShading />

          <div style={{ position: 'relative', height: '300px' }}>
            <SavingsEstimate
              showLoan={showLoan}
              setShowLoan={setShowLoan}
              savings={savings}
              products={products}
              style={{
                marginTop: '32px',
                marginLeft: STANDARD_MARGIN,
                marginRight: STANDARD_MARGIN,
              }}
              financing={financing}
            />

            {showLoan ? (
              <LoanDisclaimer
                ref={scrollReference}
                style={{ paddingLeft: STANDARD_MARGIN, paddingRight: STANDARD_MARGIN, height: '80px' }}
              />
            ) : (
              <div ref={scrollReference} style={{ height: '80px' }} />
            )}
          </div>
        </MobileBottomPart>
      )}
    </Root>
  );
};
